import { getLocale } from "../runtime";

const sv_supportemail = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `support@happygreen.se`
};

const supportemail = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_supportemail(inputs)
	return "supportEmail";
};

export { supportemail as "supportEmail" };